import React from "react";
import { Box, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const Card = React.forwardRef(({ children, sx = {}, ...props }, ref) => {
  const theme = useTheme();

  return (
    <Paper
      ref={ref}
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        borderRadius: "12px",
        border: `1px solid ${theme.palette.divider}`,
        transition: "all 0.2s",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: theme.palette.divider,
          borderRadius: "3px",
          "&:hover": {
            backgroundColor: theme.palette.text.secondary,
          },
        },
        scrollbarWidth: "thin",
        scrollbarColor: `${theme.palette.divider} transparent`,

        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
});

Card.displayName = "Card";

export const CardHeader = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        padding: "24px 24px 0 24px",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CardContent = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        padding: "0 24px 24px 24px",
        "&:only-child": {
          padding: "24px",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CardTitle = ({ children, sx = {}, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      component="h4"
      sx={{
        margin: 0,
        fontSize: "1.125rem",
        fontWeight: 450,
        lineHeight: 1,
        color: theme.palette.text.primary,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CardDescription = ({ children, sx = {}, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      component="p"
      sx={{
        margin: "0.25rem 0rem 0rem 0r",
        color: theme.palette.text.secondary,
        fontSize: "0.875rem",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CardFooter = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "0 24px 24px 24px",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
